import "../../components/ProfileCard/ProfileCard.scss";
import {FormEvent, useState} from "react";
import axios from "axios";
import {useUserStore} from "../../../../../modules/shop/user/store";
import Toaster from "../../../../shared/Toaster";
import {PATHS_API} from "../../../../../enum";
import {ToasterProps} from "../../../../shared/Toaster/Toaster";

const DISCORD_URL = "https://discord.gg/GC44JMuAGQ";
// спінер крутиться щонайменше стільки, навіть якщо сервер відповів миттєво, — інакше він лише блимає
const MIN_SPIN_MS = 500;

const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

// Бонус-код: поле з кнопкою (працює й Enter) і підказка, де брати коди
const BonusCode = () => {
    const [bonusCode, setBonusCode] = useState("")
    const [isLoading, setIsLoading] = useState(false);
    const [toastProps, setToastProps] = useState<ToasterProps | null>(null);
    const fetchUser = useUserStore(store => store.fetchUser)

    const submit = async (e: FormEvent) => {
        e.preventDefault();
        const code = bonusCode.trim();
        if (!code || isLoading) return;

        setIsLoading(true);
        const startedAt = Date.now();
        let toast: ToasterProps;
        try {
            const { data } = await axios.get(`${PATHS_API.BONUSCODE}/${encodeURIComponent(code)}`, { withCredentials: true });
            toast = { message: data.message, type: data.status === 201 ? "success" : "error", id: data.id };
            fetchUser();
            setBonusCode("");
        } catch (error: any) {
            toast = { message: error.response?.data?.message || "Сталася помилка", type: "error", id: error.response?.data?.id };
        }
        await wait(MIN_SPIN_MS - (Date.now() - startedAt));
        setToastProps(toast);
        setIsLoading(false);
    };

    return (
        <div className="bonus-code-profile-child bc-page">
            <form className="bc-card" onSubmit={submit}>
                <div className="bc-icon" aria-hidden="true">
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="8" width="18" height="4" rx="1" />
                        <path d="M12 8v13" />
                        <path d="M19 12v7a2 2 0 01-2 2H7a2 2 0 01-2-2v-7" />
                        <path d="M7.5 8a2.5 2.5 0 010-5C9.5 3 11 5.5 12 8c1-2.5 2.5-5 4.5-5a2.5 2.5 0 010 5" />
                    </svg>
                </div>
                <h3 className="bc-title">Активуй бонус-код</h3>
                <p className="bc-text">Введи код — бонус одразу потрапить на баланс. Кожен код можна використати один раз.</p>

                <div className="bc-field">
                    <input
                        className="bc-input"
                        value={bonusCode}
                        onChange={(e) => setBonusCode(e.target.value)}
                        placeholder="Наприклад, wipe2024"
                        autoComplete="off"
                        spellCheck={false}
                        maxLength={64}
                        aria-label="Бонус-код"
                    />
                    {/* під час запиту текст лишається невидимим, щоб кнопка не міняла ширину, а спінер стоїть по центру */}
                    <button
                        type="submit"
                        disabled={!bonusCode.trim() && !isLoading}
                        aria-busy={isLoading}
                        className={`bc-submit ${isLoading ? "is-loading" : ""}`}
                    >
                        <span className="bc-submit-text">Активувати</span>
                        { isLoading && <span className="bc-spinner" aria-hidden="true" /> }
                    </button>
                </div>
            </form>

            <div className="bc-hint">
                <div>
                    <b>Де взяти код?</b>
                    <span>Коди іноді з'являються в нашому Discord. Головне — встигни, поки діють!</span>
                </div>
                <a className="bc-discord" href={DISCORD_URL} target="_blank" rel="noopener noreferrer">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M19.3 5.4A16.5 16.5 0 0015.2 4l-.5 1a15 15 0 00-5.4 0l-.5-1a16.5 16.5 0 00-4.1 1.4C2 9.3 1.3 13.1 1.7 16.8a16.6 16.6 0 005 2.6l1.1-1.7c-.6-.2-1.2-.5-1.7-.8l.4-.3a11.8 11.8 0 0011 0l.4.3c-.5.3-1.1.6-1.7.8l1.1 1.7a16.6 16.6 0 005-2.6c.5-4.3-.8-8-3-11.4zM8.7 14.5c-1 0-1.8-.9-1.8-2s.8-2 1.8-2 1.8.9 1.8 2-.8 2-1.8 2zm6.6 0c-1 0-1.8-.9-1.8-2s.8-2 1.8-2 1.8.9 1.8 2-.8 2-1.8 2z" />
                    </svg>
                    Discord
                </a>
            </div>

            {toastProps && <Toaster message={toastProps.message} type={toastProps.type} id={toastProps.id} />}
        </div>
    );
};

export default BonusCode;
